import { css } from 'aphrodite';
import * as React from 'react';
import { IPrizeLog } from '../../../extViewmodels';
import { getDisplayName } from '../../../models/NameUtils';
import { PrizesList } from './components/PrizesList';
import { styleSheet } from './styles';

export interface ILeaderBoardProps {
	data: IPrizeLog[];
	renderEmptyState?: string | JSX.Element;
	renderFilter: JSX.Element;
}

export const PrizesScore: React.FC<ILeaderBoardProps> = ({ data, renderEmptyState, renderFilter }) => {
	return (
		<div className={css(styleSheet.dayBoard)}>
			{renderFilter}
			<h2 className={css(styleSheet.heading)}>Winner, winner, chicken dinner!</h2>
			{renderEmptyState ? (
				renderEmptyState
			) : (
				<div className={css(styleSheet.prizes)}>
					{data.map(item => (
						<PrizesList
							key={item.gameToken.id}
							date={item.gameToken.redemptionDate}
							name={getDisplayName(item.gameToken.creator)}
							prize={item.gameToken.gameOutcome.prize}
						/>
					))}
				</div>
			)}
		</div>
	);
};
